import { Component } from 'react';
import { connect } from 'react-redux';
import LoadingBox from '../../components/LoadingBox';
import { useSelector } from '../../util/store/store';
import {
    CONTRACT_PERMISSION_TYPE,
    CONTRACT_STATUS,
    CONTRACT_TYPE,
    contractPermissionType
} from "../../util/varibles/constants";
import { firstLetter, formatDate } from "../../util/varibles/global";
import HiredVessels from "./HiredVessels";
import OwnVessel from "./OwnVessel";
import { vesselManagementActions } from "./reducer";
import styles from "./style.module.scss";

const listOfColumn = {
    code: {
        title: <span className='pl-3'>Code</span>,
        dataIndex: 'contract_code',
        key: 'contract_code',
        width: '100px',
        render: (text: string) => <span className='pl-3'>{text}</span>
    },
    permission: {
        title: 'Type',
        key: 'permission',
        width: '300px',
        render: (record: any) => {
            const { type, permission } = record;
            if (type === CONTRACT_TYPE.FIXED) {
                return <span>-</span>
            } else {
                const { name } = contractPermissionType[permission] || contractPermissionType[CONTRACT_PERMISSION_TYPE.BASIC];
                return <span>{name}</span>
            }
        },
    },
    tenant_name: {
        title: 'Customer',
        dataIndex: 'tenant_name',
        key: 'tenant_name',
        width: '180px',
        render: (text: number) => <span>{text}</span>,
    },
    start_time: {
        title: 'Start time',
        dataIndex: 'start_time',
        key: 'start_time',
        width: '130px',
        render: (text: number) => <span>{formatDate(text)}</span>,
    },
    finish_time: {
        title: 'Finish time',
        dataIndex: 'finish_time',
        key: 'finish_time',
        width: '130px',
        render: (text: number) => <span>{formatDate(text)}</span>,
    },
    status: {
        title: 'Status',
        dataIndex: 'spot_status',
        key: 'status',
        width: '130px',
        render: (status: any) => {
            let statusText, statusCode;
            switch (status) {
                case CONTRACT_STATUS.INACTIVE:
                    statusText = 'Canceled';
                    statusCode = -1;
                    break;
                case CONTRACT_STATUS.DECLINE:
                    statusText = 'Decline'
                    statusCode = -1;
                    break;
                case CONTRACT_STATUS.COMPLETE:
                    statusText = 'Active'
                    statusCode = 1;
                    break;
                default:
                    statusText = firstLetter(status)
                    statusCode = 0;
            }
            return <div
                className={styles['contract-status']}
                data-status-code={statusCode}
            >
                {statusText}
            </div>
        },
    },
}

const LoadingSection = ({ children }: { children: React.ReactNode }) => {
    const loading = useSelector(state => state.vesselManagement.loadingList);
    return <>
        {loading ? <LoadingBox loading /> : children}
    </>;
}

interface IProps {
    getData(): void
}

class VesselManagementPage extends Component<IProps> {
    constructor(props: IProps) {
        super(props);
        this.props.getData();
    }

    render() {
        const columnsOwnVessel = [
            listOfColumn.code,
            listOfColumn.permission,
            listOfColumn.tenant_name,
            listOfColumn.start_time,
            listOfColumn.status
        ];
        const columnsHiredVessel = [
            listOfColumn.code,
            listOfColumn.permission,
            listOfColumn.start_time,
            listOfColumn.status
        ]

        return <div className='m-header bgPage'>
            <div className='header-page'>
                <div className='title-page'>
                    <b>Vessel Management</b>
                </div>
            </div>
            <div className={['body-page', styles.body].join(' ')} data-box='true'>
                <LoadingSection >
                    <>
                        <OwnVessel columns={columnsOwnVessel} />
                        <HiredVessels columns={columnsHiredVessel} />
                    </>
                </LoadingSection>
            </div>
        </div>;
    }
}

export default connect(null, {
    getData: vesselManagementActions.getListRequest
})(VesselManagementPage);
